define([], () => {
  const ANNOUNCE_DELAY = 100;

  // Shared across instances: the email and password pairs can both fail on one
  // submit, and only the first in document order should take focus.
  let focusedSubmit = null;

  function ConfirmationField(config) {
    this.form = config.form;
    this.field = config.field;
    this.message = config.field.dataset.confirmMessage;
    this.confirmWith = config.confirmWith;
    this.announceTimer = null;
  }

  ConfirmationField.prototype = {
    // Screen readers only reliably announce content that changes inside a region
    // already in the accessibility tree, so the region is built empty and stays
    // displayed rather than being unhidden at error time. `.red` is a color-only
    // class, so an empty div occupies no space.
    _buildErrorMessage() {
      this.errorMessage = document.createElement('div');
      this.errorMessage.classList.add('red');
      this.errorMessage.id = `${this.confirmWith.id}_error`;
      this.errorMessage.setAttribute('role', 'alert');
      $(this.confirmWith).after(this.errorMessage);

      const describedBy = this.confirmWith.getAttribute('aria-describedby');
      this.confirmWith.setAttribute(
        'aria-describedby',
        describedBy ? `${describedBy} ${this.errorMessage.id}` : this.errorMessage.id
      );
    },

    _clearError() {
      clearTimeout(this.announceTimer);
      this.errorMessage.textContent = '';
      this.confirmWith.removeAttribute('aria-invalid');
    },

    _setupListeners() {
      $(this.form).on('submit', (event) => {
        if ($(this.field).val() === $(this.confirmWith).val()) return;

        this._showError(event);

        // AIDEV-NOTE: `return false` (preventDefault + stopPropagation), never a bare
        // preventDefault — rails-ujs delegates `data-disable-with` from `document`, so a
        // blocked submit that reaches document leaves the button stuck on "Creating Account…".
        return false;
      });

      // `input` rather than `change`/`keyup` so paste, autofill and password
      // managers dismiss the message too. Readonly fields never fire it, which
      // is correct: they can't be the cause of a mismatch.
      $(this.field).add(this.confirmWith).on('input', () => this._clearError());
    },

    _showError(event) {
      this.confirmWith.setAttribute('aria-invalid', 'true');
      clearTimeout(this.announceTimer);

      if (this.errorMessage.textContent === '') {
        this.errorMessage.textContent = this.message;
      } else {
        // Left over from an earlier submit. Writing the same string back into a
        // live region is not reliably re-announced, so blank it first.
        this.errorMessage.textContent = '';
        this.announceTimer = setTimeout(() => {
          this.errorMessage.textContent = this.message;
        }, ANNOUNCE_DELAY);
      }

      if (focusedSubmit !== event) {
        focusedSubmit = event;
        this.confirmWith.focus();
      }
    },

    init() {
      // Nothing to compare against: bail out instead of mismatching against
      // `undefined` on every submit, which would block the form for good with an
      // error message that has nowhere to render.
      if (!this.confirmWith) return;

      this._buildErrorMessage();
      this._setupListeners();
    }
  };

  return ConfirmationField;
});
